module.exports = __webpack_public_path__ + "static/pinkdoubleknit-76dd498639d02c01ed52bb9b09c3e0d0.jpeg";